// extracted by mini-css-extract-plugin
export default {"SendPasswordLink":"SendPasswordLink_SendPasswordLink__X5unD","Title":"SendPasswordLink_Title__4RVqG","Back":"SendPasswordLink_Back__Wyx9r"};